package uz.ferro.erp.ui

import mui.material.Stack
import mui.material.StackDirection
import mui.system.PropsWithSx
import mui.system.responsive
import react.FC
import react.PropsWithChildren
import web.cssom.Length

external interface StackLayoutProps : PropsWithChildren, PropsWithSx {
    var isHorizontal: Boolean
    var space: Length?
    var onClick: (() -> Unit)?
}

val VerticalLayout = FC<StackLayoutProps> { props ->
    StackLayout {
        isHorizontal = false
        space = props.space
        children = props.children
        onClick = props.onClick
        sx = props.sx
    }
}

val HorizontalLayout = FC<StackLayoutProps> { props ->
    StackLayout {
        isHorizontal = true
        space = props.space
        children = props.children
        onClick = props.onClick
        sx = props.sx
    }
}

val StackLayout = FC<StackLayoutProps> { props ->
    Stack {
        direction = responsive(if (props.isHorizontal) StackDirection.row else StackDirection.column)
        if (props.space != null) {
            spacing = responsive(props.space!!)
        }
        sx = props.sx
        if (props.onClick != null) {
            onClick = {
                props.onClick?.invoke()
            }
        }
        +props.children
    }
}